import { render, staticRenderFns } from "./FooterBlock.vue?vue&type=template&id=25fd7e22"
import script from "./FooterBlock.vue?vue&type=script&lang=ts"
export * from "./FooterBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports